var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "31px",
    viewBox: "0 0 29 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.760784 0 0 0 0 0.321569 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content-Explorer---For-your-accounts",
    transform: "translate(-1389.000000, -151.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AssetType_Custom-BIG",
    transform: "translate(1362.000000, 134.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.58847826,29 L24.4115217,29 C25.8415734,28.99844 27,27.8813397 27,26.5038665 L27,13.1553471 C27,12.9470907 26.9042075,12.7495305 26.7388043,12.6154134 L20.2461737,8.40434061 L20.2461737,10.4628847 L24.9453135,13.1553471 L13.5,20.6884247 L2.17589309,13.1553471 L6.02161577,10.4628847 L6.02161577,8.40434061 L0.261195652,12.6154134 C0.0957925401,12.7495305 0,12.9470907 0,13.1553471 L0,26.5038665 C0,27.8813397 1.15842659,28.99844 2.58847826,29 Z M24.408587,27.5865609 L2.58847826,27.5865609 C1.96884461,27.5850025 1.4673913,27.1007198 1.4673913,26.5038665 L1.4673913,14.5037681 L9.83152174,20.2027547 L3.89445652,24.5787623 C3.57028939,24.8129486 3.50459204,25.2559214 3.74771739,25.5681697 C3.99084274,25.8804181 4.45072417,25.9436999 4.7748913,25.7095137 L11.0876087,21.056472 L13.1419565,22.4699111 C13.3960348,22.6432584 13.7360304,22.6432584 13.9901087,22.4699111 L16.0444565,21.056472 L22.3601087,25.701033 C22.6842758,25.9352193 23.1441573,25.8719375 23.3872826,25.5596891 C23.630408,25.2474408 23.5647106,24.804468 23.2405435,24.5702817 L17.3152174,20.2027547 L25.5326087,14.6055357 L25.5326087,26.5066933 C25.5309959,27.102443 25.0300117,27.5850074 24.4115217,27.5865609 L24.408587,27.5865609 Z M10.3925199,8.7435948 L11.8337214,10.1708929 L11.8337214,1.34697395 C11.8337214,0.602774277 12.4426602,0 13.1944707,0 C13.9462813,0 14.5552201,0.602774277 14.5552201,1.34697395 L14.5552201,10.1743255 L15.995728,8.74840052 C16.5304567,8.21908506 17.3973969,8.21908506 17.9307385,8.74840052 C18.4654673,9.27771597 18.4654673,10.1351933 17.9307385,10.6638222 L14.1675244,14.3889398 C13.8998133,14.6546273 13.5481823,14.7864413 13.1965514,14.78576 C13.1937772,14.78576 13.1930836,14.78576 13.1923901,14.78576 C12.8407591,14.7864413 12.4891282,14.6546273 12.221417,14.3889398 L8.45820292,10.6610761 C7.92347419,10.1317606 7.92347419,9.27359678 8.45820292,8.7435948 C8.99223809,8.21496588 9.85848476,8.21496588 10.3925199,8.7435948 Z",
    id: "Shape",
    stroke: "#7E7E7E",
    strokeWidth: 1.1826,
    fill: "#7E7E7E",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/Drop.77d9ff6e.svg";
export { ForwardRef as ReactComponent };